import React from 'react';
import { useSelector } from 'react-redux';
import { getCurrentPage } from '../store/currentPageReducer';
import AddMenu from './AddMenu';
import './Footer.scss';

function Footer() {
    const currentPage = useSelector(getCurrentPage);

    if (currentPage !== '/') {
        return null;
    } 

    return (
        <div className="footer-wrapper">
            <AddMenu />
        </div>
    )
}

export default Footer;